import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MockApiService {

  constructor(private _HttpClient: HttpClient) { }

  getMockData(path: string) {
    let fileName = path.split('/PreNexGenBackendV2')[1].replace(/\//g, '_').replace(/^_/, '');
    // console.log(fileName);

    return this._HttpClient.get(`/assets/logs/${fileName}.json`).pipe(switchMap((res: any) => {
      // console.log(res);
      return of(res.response.body)
    }));
  }

}
